export default __webpack_public_path__ + "static/clarence-d6488da1fc64ee6952ffcc440c5016e3.jpg";